/* Component: IconChevron
 * Author:    AM
 * Date:      02/08/2021
 *      Fixed version of the original IconChevron
 *      This'll version will break any existing IconChevron's that exist that rely on changing the viewport to appear correctly. Update with caution!
 */
import React, { useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';

export const chevronDirections = {
    DOWN: 0,
    LEFT: 1,
    BACK: 1,
    PREV: 1,
    UP: 2,
    RIGHT: 3,
    NEXT: 3
};

const IconChevron = ({
    size = 50,
    style,
    disabled = false,
    onClick,
    fill,
    direction = chevronDirections.DOWN,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='15 14 22 13.2'
            xmlns='http://www.w3.org/2000/svg'
            transform={`rotate(${90 * direction})`}
            onClick={onClick}
            fill={disabled ? '#cccccc' : fill}
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(ref, disabled, onClick, fill)}
            {...props}
        >
            <path d='M25.929 22.8l-8.8-8.8L15 16.129 25.929 27.2 37 16.129 34.729 14z' />
        </svg>
    );
};

export default IconChevron;
